import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=559f3cb6&scoped=true&"
import script from "./reset-password.vue?vue&type=script&lang=js&"
export * from "./reset-password.vue?vue&type=script&lang=js&"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=559f3cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f3cb6",
  null
  
)

/* custom blocks */
import block0 from "./reset-password.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports